import { CollapseList as CollapseListBase } from '../collapse-list';
import { CollapseListItem } from '../collapse-list-item';
import { CollapseListSectionItem } from '../collapse-list-section-item';
export const CollapseList = Object.assign(CollapseListBase, {
  Item: CollapseListItem,
  SectionItem: CollapseListSectionItem
});
//# sourceMappingURL=collapse-list-compound.js.map